import { DisputesFilters } from '../request-models/disputes-filters.model';
import { ResolveDisputeRequest } from '../request-models/resolve-dispute-request.model';
import { omitUndefined } from './wire-value-utils';

/**
 * POST /admin/disputes/:id/resolve body. `refundAmount` (dollars) is only sent for a split, which is the only
 * resolution the hub reads it for; blank notes are not sent.
 */
export function toResolveDisputeRequest(fields: ResolveDisputeRequest): ResolveDisputeRequest {
  return omitUndefined<ResolveDisputeRequest>({
    resolutionType: fields.resolutionType,
    refundAmount: fields.resolutionType === 'split' ? fields.refundAmount : undefined,
    resolutionNotes: fields.resolutionNotes?.trim() || undefined,
  });
}

/** Query for GET /admin/disputes (paged with `limit` / `offset`). Blank values are not sent. */
export function toDisputesQuery(filters: DisputesFilters): Record<string, string | number | undefined> {
  return {
    status: filters.status || undefined,
    reasonCode: filters.reasonCode || undefined,
    createdAtFrom: filters.createdAtFrom || undefined,
    createdAtTo: filters.createdAtTo || undefined,
    limit: filters.limit ?? undefined,
    offset: filters.offset ?? undefined,
  };
}
